<template>
  <div>
    <a-form class="ant-advanced-search-form">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="学员姓名">
            <a-input placeholder="学员姓名/手机号" v-model="where.keyword.name" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="单位名称">
            <a-input placeholder="单位名称" v-model="where.keyword.company" />
          </a-form-item>
        </a-col>
        <a-col :span="5">
            <a-form-item label="用户组">
                <a-select show-search v-model="where.keyword.groupId" :filter-option="filterOption" allowClear @change="groupChanged">
                    <a-select-option
                            :value="info.id"
                            v-for="(info, index) in grouplist"
                            :key="index"
                    >{{info.name}}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-col>
        <a-col :span="3" :style="{ textAlign: 'left' }">
          <a-button type="primary" @click="searchList">搜索</a-button>
        </a-col>
      </a-row>
    </a-form>

    <a-table
      :columns="list.columns"
      rowKey="id"
      :pagination="list.pagination"
      @change="onChange"
      :dataSource="list.datas"
      :loading="isloading"
      :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows,getCheckboxProps:getCheckboxProps}"
      :locale="{emptyText:'暂无数据'}"
    ></a-table>
    <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
      <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
      <pxkeji-btn name="确定保存" type="primary" class="nextBtn" @click="saveStudent" />
    </a-form-item>
  </div>
</template>
<script>
var that;

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号",
  },
  // {
  //   dataIndex: "address",
  //   key: "address",
  //   align: "center",
  //   title: "地区"
  // },
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "学员名称",
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号",
  },
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号",
  },
  {
    dataIndex: "sex",
    key: "sex",
    align: "center",
    title: "性别",
  },
  {
    dataIndex: "enterprise.name",
    key: "enterpriseName",
    align: "center",
    title: "单位名称",
  },
  {
    dataIndex: "administration",
    key: "administration",
    align: "center",
    title: "管理组名称",
  },
];

export default {
  props: {
    id: String,
  },
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      addedit: {
        num: 0,
        visible: false,
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          company: "",
          groupId: "", //2021 11 09
        },
      },
      selectRows: [], //选中项编号
      allSelectRows: {},
      isloading: false,
      grouplist: [],
      visible: false, //弹框
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.getgrouplist();
      this.GetList();
    });
  },
  watch: {
    selectRows: function () {},
  },
  methods: {
    // 2021 11 09 start
    filterOption(input, option) {
     return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 2021 11 09 end
    groupChanged(v) {
      this.where.keyword.groupIds = v;
    },
    getgrouplist() {
      this.isloading = true;
      this.$api.usergroup
        .getAll()
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    getCheckboxProps(record) {
      var checked = false;

      var currentlist = this.allSelectRows[this.list.pagination.current];

      for (var i in currentlist) {
        if (currentlist[i] == record.id) {
          checked = true;
          break;
        }
      }

      return {
        defaultChecked: checked,
      };
    },
    cancelClick() {
      this.$emit("callbackMethod");
    },
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      // this.clearRows();
      this.$api.student
        .getPagedList({
          pageNow: this.list.pagination.current,
          pageSize: this.list.pagination.defaultPageSize,
          name: this.where.keyword.name,
          enterpriseName: this.where.keyword.company,
          groupId: this.where.keyword.groupId,
        })
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调

      this.list.pagination.current = page.current;

      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      this.selectRows = selectedRowKeys;
      this.allSelectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      //清空选择
      for (var key in this.allSelectRows) {
        delete this.allSelectRows[key];
      }
      this.selectRows = [];
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {},
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then((res) => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },

    saveStudent() {
      var allids = [];
      for (var row in this.allSelectRows) {
            if (allids.indexOf(this.allSelectRows[row]) == -1) {
              allids.push(this.allSelectRows[row]);
            }


      }
      if (allids.length == 0) {
        this.$message.error("请选择用户");
        return;
      }

      var selList = allids.join(",");
      this.$api.examination
        .saveRecordBatch(that.id, selList)
        .then((res) => {
          that.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.$emit("callbackMethod");
            that.$message.success(res.errorMsg);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    // save() {
    //     this.addedit.visible = false;
    //     this.GetList();
    // }
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
.nextBtn {
  margin-left: 20px;
}
</style>

